import React, { useEffect, useState } from 'react'
import SliderBar from 'react-rangeslider'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { auth } from '../../../firebase'
import cloudFunctions from '../../../Helpers/cloudFunctions'
import Fade from 'react-reveal/Fade'
export default function Slider({ poll, pollID, showResults, cta, privatePoll }) {
    const [sliderValue, setSliderValue] = useState(0)
    const [averageValue, setAverageValue] = useState(null)
    const [showResultsLocal, setShowResultsLocal] = useState(showResults)
    const navigate = useNavigate()
    useEffect(() => {
        setShowResultsLocal(showResults)
    }, [showResults])
    useEffect(() => {
        if (showResultsLocal && averageValue === null) {
            const ttl = poll.total
            const average = ttl <= 0 ? 0 : (ttl / (poll.votersCount || 1))
            setAverageValue(average)
        }
    }, [showResultsLocal])
    useEffect(() => {
        if (averageValue !== null) {
            setShowResultsLocal(true)
        }
    }, [averageValue])
    return (
        <div>
            <div style={{ boxShadow: "0px 0px 10px rgba(0,0,0,.1)", width: "100%", borderRadius: 20, padding: "40px" }} className="bb">
                <div className='flex jcsb aic bb' style={{ flex: 1, padding: "10px 10px" }}>
                    <p style={{ fontSize: 35, margin: 0 }}>{poll.selectedSliderEmojiOne.emoji}</p>
                    <div style={{ width: "100%", padding: "0 20px" }}>
                        <SliderBar
                            min={0}
                            max={100}
                            value={averageValue === null ? sliderValue : averageValue}
                            onChange={value => setSliderValue(value)}
                            className="slider"
                            tooltip={false}
                            handleLabel={showResultsLocal ? <Fade duration={300} bottom><div style={{ position: "relative", bottom: 50, right: 28, width: "fit-content", background: "#0074D9", padding: 10, borderRadius: 20, color: "#fff", fontWeight: "bold" }}><p style={{ margin: 0 }}>Average</p></div></Fade> : null}
                        />
                    </div>
                    <p style={{ fontSize: 35, margin: 0 }}>{poll.selectedSliderEmojiTwo.emoji}</p>
                </div>
            </div>
            <button className={`b5 flex aic jcc ${showResultsLocal || !auth.currentUser ? "disabled" : ""}`} style={{ gap: 10, marginTop: 30 }} onClick={() => {
                if (!auth.currentUser) {
                    return navigate("/login")
                }
                const loader = toast.loading("Submitting your vote")
                cloudFunctions.vote({
                    pollID: pollID,
                    option: sliderValue,
                    private: privatePoll
                }).then((res) => {
                    if (res.error) {
                        toast.update(loader, {
                            render: res.msg,
                            icon: "❌"
                        })
                    } else {
                        toast.update(loader, {
                            render: "Vote submitted!",
                            icon: "✔️"
                        })
                        if (cta) window.open(cta)
                        setAverageValue(res.data.data.average)
                    }
                }).catch((err) => {
                    toast.update(loader, {
                        render: "Something went wrong!",
                        icon: "❌"
                    })
                }).finally(() => {
                    setTimeout(() => {
                        toast.dismiss(loader)
                    }, 2000)
                })

            }}>
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.75 11.25V6.75C24.75 5.50125 23.7375 4.5 22.5 4.5H4.5C3.2625 4.5 2.26125 5.50125 2.26125 6.75V11.25C3.49875 11.25 4.5 12.2625 4.5 13.5C4.5 14.7375 3.49875 15.75 2.25 15.75V20.25C2.25 21.4875 3.2625 22.5 4.5 22.5H22.5C23.7375 22.5 24.75 21.4875 24.75 20.25V15.75C23.5125 15.75 22.5 14.7375 22.5 13.5C22.5 12.2625 23.5125 11.25 24.75 11.25ZM22.5 9.6075C21.1612 10.3837 20.25 11.8462 20.25 13.5C20.25 15.1538 21.1612 16.6163 22.5 17.3925V20.25H4.5V17.3925C5.83875 16.6163 6.75 15.1538 6.75 13.5C6.75 11.835 5.85 10.3837 4.51125 9.6075L4.5 6.75H22.5V9.6075ZM12.375 16.875H14.625V19.125H12.375V16.875ZM12.375 12.375H14.625V14.625H12.375V12.375ZM12.375 7.875H14.625V10.125H12.375V7.875Z" fill="white" />
                </svg>
                Submit
            </button>
        </div>
    )
}
